import React from 'react'
import Contact from '../components/Contact'

const ContactScreen = () => {
    return <Contact />
}

export default ContactScreen;